import { useState, useEffect } from 'react';
import { Box, Typography, Container, useTheme } from '@mui/material';
import SliderHeroImage2 from '../../assets/sliderHero/sliderHeroImage2.svg';
import SliderHeroImage4 from '../../assets/sliderHero/sliderHeroImage4.svg';
import SliderHeroImage6 from '../../assets/sliderHero/sliderHeroImage6.svg';
import SliderHeroImage8 from '../../assets/sliderHero/sliderHeroImage8.svg';
import SliderHeroImage10 from '../../assets/sliderHero/sliderHeroImage10.svg';
import StartCreatingButton from '../../components/StartCreatingButton ';

const heroImages = [
  SliderHeroImage10,
  SliderHeroImage2,
  SliderHeroImage8,
  SliderHeroImage4,
  SliderHeroImage6,
];

export const LPSectionHero = () => {
  const theme = useTheme();

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentImageIndex(prevIndex => (prevIndex + 1) % heroImages.length);
        setFade(true);
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        height: '88vh',
        overflow: 'hidden',
        position: 'relative',
        [theme.breakpoints.down('md')]: {
          height: '40vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }
      }}
    >
      {/* Background Image with Fade Effect */}
      <Box
        sx={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          backgroundImage: `url(${heroImages[currentImageIndex]})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transition: 'opacity 0.8s ease-in-out',
          opacity: fade ? 1 : 0,
          zIndex: 1,
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(50deg, rgba(0, 0, 0, 0.8) 27%, transparent 80%)',
            pointerEvents: 'none'
          }
        }}
      />

      {/* Foreground Content */}
      <Container
        maxWidth="xl"
        sx={{
          position: 'relative',
          height: '100%',
          zIndex: 2,
          display: 'flex',
          alignItems: 'end',
          [theme.breakpoints.down('md')]: {
            height: '40vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: { xs: '100%', md: '500px' },
            maxWidth: '100%',
            gap: '1rem',
            marginBottom: '8rem',
            px: { xs: 2, md: 2 },
            [theme.breakpoints.down('md')]: {
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '0',
            }
          }}
        >
          <Typography
            variant="h2"
            component="h1"
            fontFamily="Inter"
            sx={{
              fontFamily: 'Inter',
              fontWeight: 300,
              fontSize: { xs: '2.5rem', sm: '2.75rem', md: '41.8px' },
              lineHeight: '110%',
              letterSpacing: '2px',
              color: '#ffffff',
              mb: 1,
              [theme.breakpoints.down('md')]: {
                textAlign: 'center',
                fontSize: '29px'
              }
            }}
          >
            No shoots. No agency. Branded content at scale.
          </Typography>

          <StartCreatingButton maxHeight="52px" maxWidth="200px" marginTop='10px' />
        </Box>
      </Container>
    </Box>
  );
};
